import { render, staticRenderFns } from "./ChangeCompanyIsDisabledCell.vue?vue&type=template&id=088d3e42&"
import script from "./ChangeCompanyIsDisabledCell.vue?vue&type=script&lang=ts&"
export * from "./ChangeCompanyIsDisabledCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports